import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Checkbox,
    Box,
    ListItem,
    ListItemIcon,
    ListItemText,
    List,
} from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useParams } from 'react-router-dom';
import { useNewCourseDetail, useNewCourseDetailPro, useNewCourseDetailPro1 } from '../../assets/api/useGetApi';
import { useDialog } from '../hook/useDialog';
import MainDialogBox from './Dialog/DialogMainBox';
import { Constants, ImagePath } from '../constants';

const CourseAccordianCom = ({ action, onActionChange, item, isCheckBox = false, index }) => {
    const [expanded, setExpanded] = useState(false);
    const { slug, apartments_id } = useParams();
    const { data: newCourse } = useNewCourseDetail({ slug: slug });
    const isType5 = newCourse?.data?.type === 5;
    const { open, handleClickOpen, handleClose } = useDialog();
    const handleChange = (_, isExpanded) => {
        setExpanded(isExpanded);
    };
    const { data: newCoursePro} = useNewCourseDetailPro({ slug: slug });
    const isProCourse = newCoursePro?.data?.type === 8
    return (
        <>
            <Accordion
                disableGutters
                expanded={expanded}
                onChange={handleChange}
                sx={{
                    my: 2,
                    boxShadow: "none",
                    '&:before': {
                        display: 'none'
                    },
                    borderRadius: expanded ? "20px 20px 0 0" : "20px",
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                        bgcolor: "#F7F7F7",
                        '& .MuiAccordionSummary-content': {
                            pointerEvents: 'none',
                        },
                        border: "1px solid #DEDEDE",
                        borderRadius: expanded ? "20px 20px 0 0" : "20px",
                    }}
                >
                    <Box display="flex" alignItems="center" sx={{ pointerEvents: 'auto', py: 1 }}>
                        {
                            isCheckBox &&
                            <Checkbox
                                checked={action}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => onActionChange(e.target.checked)}
                                sx={{
                                    color: isProCourse ? "red.main" : "grey",
                                    "&.Mui-checked": {
                                        color: isProCourse ? "red.main" : "grey",
                                    },
                                    mr: 1,
                                }}
                                disabled={!isProCourse}



                            />
                        }

                        <Box>
                            <Box
                                sx={
                                    {
                                        display: 'flex',
                                        gap: 2
                                    }
                                }
                            >
                                <Typography variant='body1'>{item?.name} - Sprint{index + 1}</Typography>
                                {/* {apartments_id && <Typography
                                variant="body2"
                                color="grey.400"
                                mb={1}
                                fontSize="0.8rem"
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <CurrencyRupeeIcon sx={{ color: 'red.main', fontSize: 15 }} />


                                {item?.price}
                            </Typography>



                            } */}


                                {/* {(() => {
                                    const reduction = parseFloat(item.reduction_price);
                                    const price = parseFloat(item?.price);
                                    return !isNaN(reduction) && reduction > 0
                                        ? reduction
                                        : !isNaN(price)
                                            ? price
                                            : 0;
                                })()} */}

                            </Box>

                            <Typography variant='body2' color='grey.400' mt={1}>{item?.description}</Typography>
                        </Box>
                        {/* <Typography variant="subtitle1">{title}</Typography> */}
                    </Box>
                </AccordionSummary>

                <AccordionDetails
                    sx={{
                        border: expanded ? "1px solid #DEDEDE" : "none",
                        borderTop: "none",
                        borderRadius: "0 0 20px 20px",
                        bgcolor: "#fff"
                    }}
                >



                    {item?.learningoutcome && (
                        <Box>
                            <Typography variant="body1">
                                Learning Outcomes
                            </Typography>
                            <Typography variant="body2" color="grey.400" fontSize={"14px"}>
                                {item?.learningoutcome}
                            </Typography>
                        </Box>
                    )}

                    {
                        apartments_id && (
                            <>
                                <Typography variant="body1">
                                    Sessions
                                </Typography>
                                <List>
                                    {
                                        item?.sessions?.map((item, i) => (
                                            <ListItem key={i} sx={{ alignItems: "flex-start", py: 0 }}>
                                                <ListItemIcon sx={{ minWidth: "20px", mt: 1.5 }}>
                                                    <StopIcon sx={{ fontSize: 10 }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="body1" color="grey.400" fontSize={"14px"}>
                                                            {item?.sessionname}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItem>
                                        ))
                                    }

                                </List>
                            </>
                        )
                    }

                    {
                        (isType5 && apartments_id) &&
                        <>
                            <Typography
                                variant="body2"
                                color="red.main"
                                sx={{
                                    mt: 1,
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                }}
                                onClick={handleClickOpen}
                            > Read More</Typography>
                        </>
                    }

                </AccordionDetails>
            </Accordion>
            <MainDialogBox open={open} handleClose={handleClose} width={"40%"}>
                <Typography variant='h2'>{item?.name}</Typography>
                <Typography variant='body2' color='grey.400' my={0.5}>Age Group : {item?.age_group?.min} years - {item?.age_group?.max} years</Typography>
                <Box
                    component={"img"}
                    alt='Winner Prize'
                    src={`${ImagePath}${item?.prize_image}`}
                    sx={{
                        width: "100%",
                        height: "auto"
                    }}
                />
                <Typography variant='body2' mt={1}>Prize :
                    <span color='#6E6E6E'> {item?.prize}</span>
                </Typography>
                <Typography variant='body2' color='grey.400' my={0.5}>{item?.prize_description}</Typography>
                <Typography variant='body2'>Winner Type :
                    <span color='#6E6E6E'> {item?.winner_type}</span>
                </Typography>
                <Typography variant='body2' my={0.5}>No of Winner :
                    <span color='#6E6E6E'> {item?.no_of_winners}</span>
                </Typography>
                <Typography variant='body2' my={0.5}>Instruction For Parents :
                    <span color='#6E6E6E'> {item?.material_from_parents}</span>
                </Typography>




            </MainDialogBox>
        </>



    );
};

export default CourseAccordianCom;
